import { ExtendedFavoritesService } from "./extendedFavoritesService";

export const extendedFavoritesService = new ExtendedFavoritesService();